// Default map settings
export const MAP_CONFIG = {
    CENTER: [23.0, 78.5], // Centered on India to show all 3 city clusters
    ZOOM: 5,
    MIN_ZOOM: 2,
    MAX_ZOOM: 20,
};

// Theme colors
export const THEME_COLORS = {
    dark: {
        background: '#020813',
        card: 'rgba(2, 8, 19, 0.95)',
        text: '#ffffff',
        textSecondary: 'rgba(255, 255, 255, 0.7)',
        border: 'rgba(8, 120, 255, 0.2)'
    },
    light: {
        background: '#ffffff',
        card: 'rgba(255, 255, 255, 0.95)',
        text: '#000000',
        textSecondary: 'rgba(0, 0, 0, 0.7)',
        border: 'rgba(0, 0, 0, 0.1)'
    }
};

// AQI Category thresholds with client-specified colors
export const AQI_CATEGORIES = [
    { max: 50, label: 'Low', color: '#22c55e', textColor: '#000000', category: 'low' },
    { max: 150, label: 'Moderate', color: '#29e9de', textColor: '#000000', category: 'moderate' },
    { max: Infinity, label: 'High', color: '#F5595D', textColor: '#ffffff', category: 'high' },
];

// Offline/No data color
export const OFFLINE_COLOR = '#636363';

// Cluster configuration
export const CLUSTER_CONFIG = {
    chunkedLoading: true,
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false,
    maxClusterRadius: 80,
    disableClusteringAtZoom: 10,
};


// Official labels for regions to align representation with Google Maps worldview (in India)
// Positioned to mask incorrect basemap text (e.g. Azad Kashmir, Gilgit-Baltistan)
export const REGION_LABELS = [
    //  { name: 'Jammu & Kashmir', position: [34.0, 73.8] }, // Positioned to cover "Azad Kashmir"
    //{ name: 'Ladakh (North-West)', position: [35.4, 74.8] }, // Positioned to cover "Gilgit-Baltistan"
    //{ name: 'Ladakh', position: [34.2, 77.6] } // Standard Ladakh label
];

// Masking polygons to cover disputed labels/boundaries from basemaps
export const MASK_POLYGONS = [
    // Azad Kashmir label area
    [
        [32.8, 73.0],
        [35.15, 73.0],
        [35.15, 74.12],
        [32.8, 74.12]
    ],
    // Gilgit-Baltistan label area
    [
        [34.8, 72.0],
        [37.2, 72.0],
        [37.2, 76.5],
        [34.8, 76.5]
    ]
];
